import React, { useEffect } from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { setLoadingStatus } from '../../../common/explorer/lib/redux/slices/loadingSlice';
import { swapCountryAndLanguage } from '../utils';
import { LinkType } from '../../../common/explorer/lib/types';
import ProductsDisplay from './ProductsDisplay';
import {
  useProductExplorerDispatch,
  useProductExplorerSelector,
} from '../lib/redux/hooks';
import './ProductExplorer.scss';
import { Loading } from 'carbon-components-react';
import { CarbonThemes } from 'src/types/carbon';

export interface ProductExplorerProps {
  linkType: LinkType.product | string;
  fullWidth: boolean;
}

const ProductExplorer: React.FC<ProductExplorerProps> = ({
  linkType,
  fullWidth,
}) => {
  const loading = useProductExplorerSelector<boolean>((state) => state.loading);
  const theme = useProductExplorerSelector<CarbonThemes>(
    (state) => state.theme,
  );
  const messages = useProductExplorerSelector<
    Record<string, MessageDescriptor>
  >((state) => state.messages);
  const dispatch = useProductExplorerDispatch();
  const isFullWidth = fullWidth ? 'full-width' : '';
  const hideHeadingContainer = fullWidth ? 'hide-container' : '';

  let localeCode = useProductExplorerSelector((state) => state.localeCode);
  localeCode = swapCountryAndLanguage(localeCode);

  useEffect(() => {
    dispatch(setLoadingStatus(false));
  }, []);
  return (
    <div
      className={`product-explorer-main-offerings product-explorer-main-offerings__${theme}`}
    >
      <div className={`product-explorer-main-offerings__global ${isFullWidth}`}>
        <div
          className={`product-explorer-main-offerings__headline-wrapper ${hideHeadingContainer}`}
        >
          <h3 className="product-explorer-main-offerings__headline">
            <FormattedMessage {...messages.appHeadline} />
          </h3>
          <p className="product-explorer-main-offerings__subhead"></p>
          {localeCode === 'jp-ja' ? (
            <p className="product-explorer-main-offerings__subhead"></p>
          ) : (
            <p className="product-explorer-main-offerings__subhead"></p>
          )}
        </div>
        <div>
          {loading ? (
            <Loading withOverlay={false} />
          ) : (
            <ProductsDisplay linkType={linkType} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductExplorer;
